import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store";
import student from './student'
import timeTable from './timeTable'
// import modal from './modal'
import anlyDashboard from './anlyDashboard'
import warehouse from './warehouse'

Vue.use(Router);

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: require('@/views/User/Login').default,
        },
        {
            path: '/changePassword',
            name: 'changePassword',
            component: require('@/views/User/ChangePassword').default,
        },
        {
            path: '/warehouse/upload/:invoiceId/:type',
            name: 'warehouse/upload',
            component: require('@/views/Warehouse/Upload/Index').default,
        },
        {
            path: '/',
            name: 'Dashboard',
            component: require('@/layouts/Dashboard').default,
            beforeEnter: (to, from, next) => {
                store.commit('refreshToken', localStorage.token);
                if (store.state.token.length > 50) {
                    next();
                } else {
                    next({
                        path: '/login',
                    })
                }
            },
            children: [
                ...student,
                ...timeTable,
                ...anlyDashboard,
                ...warehouse,
                {
                    path: '',
                    name: 'WorkDashboard',
                    component: require('@/views/Home/Home.vue').default,
                },

                //学期列表
                {
                    path: "/semester/list",
                    component: require('@/views/Semester/List/Index').default,
                },
                //权限分配
                {
                    path: "/authority/list",
                    component: require('@/views/Authority/List/Index').default,
                },
                //教室管理
                {
                    path: "/classroom",
                    component: require('@/views/SettingDashboard/Classroom/Index').default,
                },
                {
                    path: "/section",
                    component: require('@/views/SettingDashboard/Section/Index').default,
                },
                //工作日历
                {
                    path: "/workSchedule",
                    component: require('@/views/SettingDashboard/WorkSchedule/Index').default,
                },
                //优惠模板
                {
                    path: "/discountType",
                    component: require('@/views/SettingDashboard/DiscountType/Index').default,
                },
                //课时管理
                {
                    path: "/classHour",
                    component: require('@/views/SettingDashboard/ClassHour/Index').default,
                },
                //商店管理
                {
                    path: "/shop",
                    component: require('@/views/SettingDashboard/Shops/Index').default,
                },
                //工作日设置
                {
                    path: "/workSchedule",
                    component: require('@/views/SettingDashboard/WorkSchedule/Index').default,
                },
                //回访列表
                {
                    path: "returnVisit/list",
                    component: require('@/views/ReturnVisit/List/Index').default,
                },
                //班主任列表
                {
                    path: "headTeacher/list",
                    component: require('@/views/HeadTeacher/List/Index').default,
                },
                //班主任额度
                {
                    path: "headTeacher/limit",
                    component: require('@/views/HeadTeacher/Limit/Index').default,
                },
                // 员工列表
                {
                    path: "employee/list",
                    component: require('@/views/Employee/List/Index').default,
                },

                //教师列表
                {
                    path: "teacher/list",
                    component: require('@/views/Teacher/List/Index').default,
                },

                //考试列表
                {
                    path: "exam/list",
                    component: require('@/views/Exam/List/Index').default,
                },
                //推荐人名单
                {
                    path: "referrer/list",
                    component: require('@/views/Referrer/List').default,
                },
                // //学期详情
                // {
                //     path: "semester/detail/:id",
                //     component: require('@/views/Semester/Info/Index').default,
                // },
                //学生上课通知列表
                {
                    path: "student/CourseNotify/list",
                    component: require('@/views/Student/CourseNotify/Index').default,
                },
                //教务
                {
                    path: "educationalAdministration",
                    component: require('@/views/EducationalAdministration/Index').default,
                },
                //教务
                {
                    path: "returnVisitDetail/:id",
                    component: require('@/views/ReturnVisit/Info/Index').default,
                },
                //学校考试
                {
                    path: "schoolExam/:id",
                    component: require('@/views/Exam/Show/SchoolExam').default,
                },
                //退费处理
                {
                    path: "refund/list",
                    component: require('@/views/Refund/Index').default,
                },
                //发送通知
                {
                    path: "message/send",
                    component: require('@/views/Message/Index').default,
                },
                //上下课通知
                {
                    path: "class/emailSending",
                    component: require('@/views/ClassSendingEmail/Index').default,
                },
                //押金管理
                {
                    path: "student/deposit/list",
                    component: require('@/views/Deposit/Index').default,
                },
                //学生管理
                {
                    path: "student/management/list",
                    component: require('@/views/Student/Management/Index').default,
                },
                //教案管理
                {
                    path: "/teacherPlan/list",
                    component: require('@/views/TeacherPlan/List/Index').default,
                },
                //教案管理
                {
                    path: "/classPackage/list",
                    component: require('@/views/ClassPackage/List/Index').default,
                },

                //续班
                {
                    path: "/renew/list",
                    component: require('@/views/Renew/List').default,
                },
                //组团
                {
                    path: "/team/list",
                    component: require('@/views/StudentTeam/Index').default,
                },
                //定金列表
                {
                    path: "/earnest/list",
                    component: require('@/views/Earnest/Index').default,
                },
            ]
        },
        // ...modal,

        {
            path: '*',
            redirect: '/404'
        }
    ]
})
